import { render, staticRenderFns } from "./ProducerReportsSales.vue?vue&type=template&id=dc97abc2&"
import script from "./ProducerReportsSales.vue?vue&type=script&lang=js&"
export * from "./ProducerReportsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports